export const dishOptionListDataSelector = state => state.dish_option.listData;

export const dishOptionStepSelector = state => state.dish_option.formStep;
export const dishOptionCompletedStepsSelector = state => state.dish_option.completedSteps;
export const dishOptionErrorsSelector = state => state.dish_option.errors;
export const dishOptionDeleteInProcessSelector = state => state.dish_option.deleteInProcess;
export const dishOptionCreateOrUpdateInProcessSelector = state => state.dish_option.createOrUpdateInProcess;
